import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
  selector: 'app-complete-profile',
  templateUrl: './complete-profile.component.html',
  styleUrls: ['./complete-profile.component.css'],
})
export class CompleteProfileComponent implements OnInit {
  user: any = {};
  dataLoaded: Boolean = false;
  accountStatusActive: Boolean = false;
  profileCompleted: Boolean = false;
  phoneNoVerifed: Boolean = false;
  fieldEmptyh: Boolean = false;
  formObjCp: any;
  errorOcc: Boolean = false;
  compprofileBtnClicked: Boolean = false;
  bname: String = '';
  bId: String = '';
  baddressL1: String = '';
  baddressL2: String = '';
  bvillage: String = '';
  bdistrict: String = '';
  bstate: String = '';
  bpincode: String = '';
  pFname: String = '';
  pLname: String = '';
  pPhoneNo: String = '';
  pEmail: String = '';
  addressL1: String = '';
  addressL2: String = '';
  village: String = '';
  district: String = '';
  state: String = '';
  pincode: String = '';
  bbname: String = '';
  branchname: String = '';
  ifsc: String = '';
  accno: String = '';
  panNo: String = '';
  gstNo: String = '';
  // storageType: String = '';
  // capacity: String;
  // suitableProduct: String;
  // lat: String = '';
  // long: String = '';
  valMsgBBname: Boolean = false;
  valMsgaccNo: Boolean = false;
  valMsgifsc: Boolean = false;
  valMsgBranchName: Boolean = false;
  valMsgPAN: Boolean = false;
  valMsgGST: Boolean = false;
  steponevalid: Boolean = false;
  steptwovalid: Boolean = false;
  stepthreevalid: Boolean = false;
  valMsgpFname: Boolean = false;
  valMsgpLname: Boolean = false;
  valMsgpPhoneNo: Boolean = false;
  valMsgpEmail: Boolean = false;
  showStepErrMsg: Boolean = false;
  valMsgBAa1: Boolean = false;
  valMsgBAa2: Boolean = false;
  valMsgBAvillage: Boolean = false;
  valMsgBAdis: Boolean = false;
  valMsgBAstate: Boolean = false;
  valMsgBAa2pincode: Boolean = false;

  constructor(
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.auth.getProfile().subscribe(
      (profile) => {
        this.user = profile['user'];
        this.bId = this.user['bankId'];
        // if (this.user['phoneVerified'] == 'false') {
        //   console.log("Phone number not verified");
        //   this.phoneNoVerifed = false;
        // } else {
        if (this.user['profileCompleted'] == 'false') {
          this.profileCompleted = false;
        } else {
          this.profileCompleted = true;
          if (this.user['accountStatus'] == 'active') {
            window.location.href = '/dashboard';
          } else {
            this.accountStatusActive = false;
          }
        }
        //}
        this.dataLoaded = true;
      },
      (err) => {
        this.router.navigateByUrl('/login');
        console.log(err, 'ERROR occurred');
        this.toastr.error('Error occurred. Please try again.');
        return false;
      }
    );
    // this.getPosition().then((pos) => {
    //   // this.lat = pos.lat;
    //   // this.long = pos.lng;
    //   console.log(`Positon: ${pos.lng} ${pos.lat}`);
    // });
  }

  // getPosition(): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     navigator.geolocation.getCurrentPosition(
  //       (resp) => {
  //         resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
  //       },
  //       (err) => {
  //         this.lat = '28.704060';
  //         this.long = '77.102493';
  //         reject(err);
  //       }
  //     );
  //   });
  // }

  step1() {
    this.showStepErrMsg = false;
    this.valMsgBBname = false;
    this.valMsgBranchName = false;
    this.valMsgGST = false;
    this.valMsgPAN = false;
    this.valMsgaccNo = false;
    this.valMsgifsc = false;
    let obj = {
      bbname: this.bbname,
      branchname: this.branchname,
      ifsc: this.ifsc,
      accno: this.accno,
      panNo: this.panNo,
      gstNo: this.gstNo,
    };
    if (!this.bbname) {
      this.valMsgBBname = true;
    }
    if (!this.branchname) {
      this.valMsgBranchName = true;
    }
    if (!this.ifsc) {
      this.valMsgifsc = true;
    }
    if (!this.accno) {
      this.valMsgaccNo = true;
    }
    if (!this.panNo) {
      this.valMsgPAN = true;
    }
    if (!this.gstNo) {
      this.valMsgGST = true;
    }
    if (
      !this.bbname ||
      !this.accno ||
      !this.branchname ||
      !this.ifsc ||
      !this.panNo ||
      !this.gstNo
    ) {
      return false;
    }
    this.steponevalid = true;
    let elem = document.getElementById('bDetailsStep');
    elem.click();
    this.bankDetails();
    let elemcpdStep = document.getElementById('badStep');
    elemcpdStep.click();
    this.bankAddd();
  }

  step12() {
    this.valMsgBAa1 = false;
    this.valMsgBAa2 = false;
    this.valMsgBAvillage = false;
    this.valMsgBAdis = false;
    this.valMsgBAstate = false;
    this.valMsgBAa2pincode = false;
    let objba = {
      baddressL1: this.baddressL1,
      baddressL2: this.baddressL2,
      bvillage: this.bvillage,
      bdistrict: this.bdistrict,
      bpincode: this.bpincode,
      bstate: this.bstate,
    };
    if (!this.baddressL1) {
      this.valMsgBAa1 = true;
    }
    if (!this.baddressL2) {
      this.valMsgBAa2 = true;
    }
    if (!this.bvillage) {
      this.valMsgBAvillage = true;
    }
    if (!this.bdistrict) {
      this.valMsgBAdis = true;
    }
    if (!this.bstate) {
      this.valMsgBAstate = true;
    }
    if (!this.bpincode) {
      this.valMsgBAa2pincode = true;
    }
    if (
      !this.baddressL1 ||
      !this.baddressL2 ||
      !this.bvillage ||
      !this.bdistrict ||
      !this.bstate ||
      !this.bpincode
    ) {
      return false;
    }
    this.stepthreevalid = true;
    let elem = document.getElementById('badStep');
    elem.click();
    this.bankAddd();
    let elemcpdStep = document.getElementById('cpdStep');
    elemcpdStep.click();
    this.contacPD();
  }

  step2() {
    this.valMsgpFname = false;
    this.valMsgpLname = false;
    this.valMsgpPhoneNo = false;
    this.valMsgpEmail = false;
    let obj = {
      pFname: this.pFname,
      pLname: this.pLname,
      pPhoneNo: this.pPhoneNo,
      pEmail: this.pEmail,
    };
    if (!this.pFname) {
      this.valMsgpFname = true;
    }
    if (!this.pLname) {
      this.valMsgpLname = true;
    }
    if (!this.pPhoneNo) {
      this.valMsgpPhoneNo = true;
    }
    if (!this.pEmail) {
      this.valMsgpEmail = true;
    }
    if (!this.pFname || !this.pLname || !this.pPhoneNo || !this.pEmail) {
      return false;
    }
    this.steptwovalid = true;
    let elem = document.getElementById('cpdStep');
    elem.click();
    this.contacPD();
    let elemcpdStep = document.getElementById('cpaStep');
    elemcpdStep.click();
    this.contacPA();
  }

  submitProfile() {
    if (!this.steponevalid || !this.steptwovalid) {
      this.showStepErrMsg = true;
      return false;
    }

    this.compprofileBtnClicked = true;

    this.formObjCp = {
      bname: this.bbname,
      baddressL1: this.baddressL1,
      baddressL2: this.baddressL2,
      bvillage: this.bvillage,
      bdistrict: this.bdistrict,
      bpincode: this.bpincode,
      bstate: this.bstate,
      pFname: this.pFname,
      pLname: this.pLname,
      pPhoneNo: this.pPhoneNo,
      pEmail: this.pEmail,
      paddressL1: this.addressL1,
      paddressL2: this.addressL2,
      pstate: this.state,
      pvillage: this.village,
      pdistrict: this.district,
      ppincode: this.pincode,
      // lat: this.lat,
      // long: this.long,
    };
    // if (!this.isEmpty(this.formObjCp)) {
    //   this.fieldEmptyh = true;
    //   let self = this;
    //   this.compprofileBtnClicked = false;
    //   setTimeout(() => {
    //     self.fieldEmptyh = false;
    //   }, 3000);
    // }
    // else {
    this.formObjCp['bbname'] = this.bbname;
    this.formObjCp['branchname'] = this.branchname;
    this.formObjCp['ifsc'] = this.ifsc;
    this.formObjCp['accno'] = this.accno;
    this.formObjCp['panNo'] = this.panNo;
    this.formObjCp['gstNo'] = this.gstNo;

    this.auth.updateProfile(this.formObjCp).subscribe(
      (data) => {
        if (data['success']) {
          this.compprofileBtnClicked = false;
          this.profileCompleted = true;
          this.accountStatusActive = false;
        } else {
          this.errorOcc = true;
          this.compprofileBtnClicked = false;
          setTimeout(() => {
            this.errorOcc = false;
          }, 300);
        }
      },
      (err) => {
        console.log(err);
        this.errorOcc = true;
        this.compprofileBtnClicked = false;
        setTimeout(() => {
          this.errorOcc = false;
        }, 300);
      }
    );
    // }
  }

  isEmpty(obj: any) {
    for (let v in obj) {
      if (obj[v] === undefined || obj[v] === '') {
        return false;
      }
    }
    return true;
  }

  bankDetails() {
    $('#expmIn').toggleClass('expMin');
    $('#expAddd').toggleClass('expAdd');
  }
  bankAddd() {
    $('#expmInBad').toggleClass('expMinCPD');
    $('#expAdddBad').toggleClass('expAddCPD');
  }

  contacPD() {
    $('#expmInCPD').toggleClass('expMinCPD');
    $('#expAdddCPD').toggleClass('expAddCPD');
  }
  contacPA() {
    $('#expmInCPA').toggleClass('expMinCPA');
    $('#expAdddCPA').toggleClass('expAddCPA');
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
}
